module.exports = __webpack_public_path__ + "static/indifi-cc752e95c45e0d2687a84fcbdb063f4c.png";